import { render, staticRenderFns } from "./modalViewEmailEvent.vue?vue&type=template&id=a3688048&"
import script from "./modalViewEmailEvent.vue?vue&type=script&lang=js&"
export * from "./modalViewEmailEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports